/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Audit_Details_Source_QueryInputs */



/**
* | output |
* | --- |
* | "Query: {query}" |
*
* @param {Audit_Details_Source_QueryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_source_query = /** @type {((inputs: Audit_Details_Source_QueryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Source_QueryInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Suchanfrage: ${i?.query}`)
	return /** @type {LocalizedString} */ (`Query: ${i?.query}`)
});